import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "secure container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "secure__title title" }, "Безопасность", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "secure__desc" }, " Использование Everypay полностью безопасно: подключение к банковскому счету осуществляется в режиме «только для получения выписок», а хранение информации в системе защищено и деперсонализировано. ", -1)
const _hoisted_4 = { class: "secure__image" }
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["src"]

import { IMAGE_BASE_URL } from '@/config'

export default /*#__PURE__*/_defineComponent({
  __name: 'SecureSect',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("picture", _hoisted_4, [
      _createElementVNode("source", {
        srcset: _unref(IMAGE_BASE_URL) + 'secure-tablet.png',
        media: "(max-width: 1100px) "
      }, null, 8, _hoisted_5),
      _createElementVNode("img", {
        src: _unref(IMAGE_BASE_URL) + 'secure.png'
      }, null, 8, _hoisted_6)
    ])
  ]))
}
}

})